import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client/core';

const httpLink = createHttpLink({
  uri: '/gcn-services/res/v2/graphql',
});

const cache = new InMemoryCache();

const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
});

export default apolloClient;
